import { queryPremiumRateForWP as queryPremiumRate } from 'core/service/rider/query-premium-rate'
import { calculateRiderPremiumForWP as calculateRiderPremium } from 'core/service/rider/premium-calculation'

const getYearsOfCoverage = (coveragePeriod, age, basicPaymentPeriod, basicPlanCoveragePeriod) => {
  const ageValue = age.unit !== 'year' ? 0 : age.value
  const yearsOfCoverage = Math.min(coveragePeriod - ageValue, basicPaymentPeriod)
  return yearsOfCoverage > basicPlanCoveragePeriod ? basicPlanCoveragePeriod : yearsOfCoverage
}

export default {
  calculateRiderPremium,
  queryPremiumRate,
  getYearsOfCoverage,
}
